const state = {
  activeFilters: {},
  showOnlyUniqueUsers: false,
};

const getters = {
  getSpecificActiveFilter: (state) => (filterName) => state.activeFilters[filterName],
  getAllActiveFilters: (state) => state.activeFilters,
  getShowOnlyUniqueUsers: (state) => state.showOnlyUniqueUsers,
};

const actions = {
  updateGlobalFilters({ dispatch, commit }, newFilters) {
    commit("setNewGlobalFilters", newFilters);
    dispatch("updateCharts");
  },
  clearGlobalFilters({ dispatch, commit }) {
    const filterCategories = ["countries", "device", "itemCategories", "products"];
    filterCategories.forEach((cat) => commit("setNewGlobalFilters", { name: cat, values: [] }));
    dispatch("updateCharts");
  },
  updateCharts({ dispatch, rootGetters }) {
    const page = rootGetters["dashboard/currentPage"];
    switch (page) {
      case "dashboard":
        dispatch("dashboard/resetAllCharts", null, { root: true });
        break;
      case "coverage":
        dispatch("coverage/setCurrentCoverageData", null, { root: true });
        break;
      case "usage":
        dispatch("usage/fetchAllUsage", null, { root: true });
        break;
      case "performance":
        dispatch("performance/fetchAllPerformance", null, { root: true });
        break;
      default:
        break;
    }
  },
  setOnlyUniqueUsers({ dispatch, commit, rootGetters }, payload) {
    commit("setUniqueUsers", payload);
    const page = rootGetters["dashboard/currentPage"];
    if (page === "usage") {
      dispatch("usage/fetchAllUsage", null, { root: true });
    } else {
      dispatch("performance/fetchAllPerformance", null, { root: true });
    }
  },
};

const mutations = {
  setNewGlobalFilters(state, payload) {
    const { name, values } = payload;
    state.activeFilters = { ...state.activeFilters, [name]: values };
  },
  setUniqueUsers(state, payload) {
    state.showOnlyUniqueUsers = payload;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
